<script>
export default {}
</script>

<template>
  <div class="page-403">
    <p class="--title">403!</p>
    <p class="--des">
      Unfortunately, you do not have permission to view this page.
    </p>
    <router-link :to="{ name: 'home' }" class="s-button red-btn">
      Back to home
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
@import '403.scss';
</style>
